import * as React from "react";
const SvgId = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", id: "flag-icons-id", viewBox: "0 0 640 480", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#e70011", d: "M0 0h640v240H0Z" }), /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M0 240h640v240H0Z" }));
export default SvgId;
